import moment from 'moment'
import { DATE_DISPLAY_FORMAT, DATE_DISPLAY_FORMAT_HOURS, DATE_DISPLAY_FORMAT_TIME_AND_DATE } from '../constants/dateFormats'

export const formatDate = (date) => {
  return moment(date || new Date()).format(DATE_DISPLAY_FORMAT)
}

export const formatDateAndTime = (date) => {
  return moment(date || new Date()).format(DATE_DISPLAY_FORMAT_HOURS)
}

export const formatTimeAndDate = (date) => {
  return moment(date || new Date()).format(DATE_DISPLAY_FORMAT_TIME_AND_DATE)
}

export const checkDurationUsageDate = (duration, includeNumber = true) => {
  const durationNumber = Number(duration)

  if (durationNumber === 1) {
    return includeNumber ? '1 ngày' : '/ ngày'
  }
  if (durationNumber === 7) {
    return includeNumber ? '1 tuần' : '/ tuần'
  }
  if (durationNumber === 30) {
    return includeNumber ? '1 tháng' : '/ tháng'
  }

  return includeNumber ? `${duration || ''} ngày` : `/ ${duration || ''} ngày`
}
